<template>
  <v-app
    class="dt-theme cmp-b2b-app-main-container"
    style="height: 100vh; overflow: hidden; background: #fff"
    :class="appThemeClass"
  >
    B2B

    <v-navigation-drawer
      @input="setDrawer"
      :class="mainNavClass"
      :dark="dark"
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      :value="appDrawer"
      :width="width"
      enable-resize-watcher
      :temporary="showtemporary"
      app
    >
      <B2BSidebarComponent
        :showtemporary="showtemporary"
        :base="'b2b'"
        :items="appNavItems"
        @closeMainNav="onCloseMainNav($event)"
      />
    </v-navigation-drawer>

    <v-content>
      <v-layout class="b2b-content" style="height: 100%" column align-center>
        <B2BHeaderComponent
          :showtemporary="showtemporary"
          @closeMainNav="onCloseMainNav($event)"
          :class="{
            inactive: !this.$store.getters.mainNavActive,
          }"
        ></B2BHeaderComponent>
        <router-view />
      </v-layout>
    </v-content>
    <ConfirmationContainer></ConfirmationContainer>
  </v-app>
</template>

<script>
import ConfirmationContainer from "../../dt-plugins/confirmation/confirmation-container";
import B2BSidebarComponent from "./b2b-sidebar";
import { B2BStoreNamespace as storeNS } from "../../modules/b2b/store/index";
import B2BHeaderComponent from "../b2b/b2b-header";
import * as types from "../../modules/b2b/store/types.js";
import { mapGetters, mapActions, mapState } from "vuex";
import { isMobile } from "../../utility";
import * as I18nActionTypes from "../../store/app/i18n/types";
export default {
  name: "App",
  components: {
    B2BSidebarComponent,
    ConfirmationContainer,
    B2BHeaderComponent,
  },

  data() {
    return {
      appThemeClass: {
        light: true,
      },
      width: 200,
      miniVariant: false,
      showtemporary: false,
      clipped: false,
      fixed: false,
      right: true,
      dark: true,
      rightDrawer: false,
      title: "Vuetify.js",
      isMobileScreen: false,
      showI18n: false,
    };
  },

  mounted() {
    if (isMobile()) {
      this.isMobileScreen = true;
    } else {
      this.isMobileScreen = false;
    }
    if (isMobile()) {
      this.$store.commit(`${storeNS}/${types.B2B_TOGGLE_SIDE_NAV}`, false);
      this.setRouteItems(true);
      this.$addToHomescreen.mount({
        iconColor: "#fff",
        iconPath: "static/icons/details_d.PNG",
      });
    } else {
      this.setRouteItems(false);
    }
  },
  computed: {
    ...mapGetters(storeNS, {
      mainNavActive: "mainNavActive",
      appNavItems: "appNavItems",
      appDrawer: "appDrawer",
      user: "user",
    }),

    mainNavClass: function () {
      return {
        "main-nav": true,
        inactive: !this.mainNavActive,
      };
    },
  },

  methods: {
    setDrawer(e) {
      if (!e) {
        this.$store.commit(`${storeNS}/${types.B2B_TOGGLE_SIDE_NAV}`, e);
      }
    },
    setRouteItems: function (permission) {
      let navItems = this.appNavItems.map((a) => {
        if (a.route === "b2bLogin" || a.route === "user_profile") {
          a.hasPermission = permission;
        }
        return a;
      });
      this.$store.commit(`${storeNS}/${types.B2B_SET_APP_NAV_ITEMS}`, navItems);
    },
    ...mapActions(storeNS, {
      // [types.B2B_FETCH_USER_DETAILS]: types.B2B_FETCH_USER_DETAILS,
    }),
    onCloseMainNav: function (event) {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          this.showtemporary = true;
          break;
        case "sm":
          this.showtemporary = true;
          break;
        case "md":
          this.showtemporary = false;
          break;
        case "lg":
          this.showtemporary = false;
          break;
        case "xl":
          this.showtemporary = false;
          break;
      }
      this.$store.commit(`${storeNS}/${types.B2B_TOGGLE_SIDE_NAV}`, event);
    },
  },
};
</script>

<style lang="scss"  >
.cmp-b2b-app-main-container {
  .container.fluid {
    background: white;
    display: flex;
    width: 100%;
    margin: 0;
    height: 100%;
    max-width: 100%;
  }
  .layout {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100% !important;
    .b2b-content {
      padding-top: 30px !important;
      height: 100% !important;
    }
  }
}
.add-to-homescreen-container div .btn-container button {
  height: 2.2em !important;
}
.add-to-homescreen-container div .icon-container .icon {
  border-radius: 0px !important;
}
</style>
